import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import {
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import PrintIcon from "@mui/icons-material/Print";
import HistoryIcon from "@mui/icons-material/History";
import LogoutIcon from "@mui/icons-material/Logout";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import NavItem from "./NavItem";
import { ListUpdate, LogOut } from "../../services/user/user";
import { useDispatch, useSelector } from "react-redux";
import { clearUserCredentials } from "../../redux/user/userSlice";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import SchoolIcon from "@mui/icons-material/School";
import EmailIcon from '@mui/icons-material/Email';
import Swal from "sweetalert2";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SettingsIcon from "@mui/icons-material/Settings";
import { useTranslation } from "react-i18next";
export default function TemporaryDrawer({ state, setState, toggleDrawer }) {
  const { t } = useTranslation();

  const profile = [
    {
      title: t("Sidebar.Setting"),
      icon: <SettingsIcon />,
      href: "/setting",
    },
  ];
  const services = [
    {
      title: t("Sidebar.Upload"),
      icon: <NoteAddIcon />,
      href: "/upload",
    },
    {
      title: t("Sidebar.History"),
      icon: <HistoryIcon />,
      href: "/history",
    },
    {
      title: t("Sidebar.Device"),
      icon: <PrintIcon />,
      href: "/device",
    },
    {
      title: t("Sidebar.Letter"),
      icon: <EmailIcon />,
      href: "/letter",
    },
  ];
  const info = [

    {
      title: t("Sidebar.Contact"),
      icon: <PhoneEnabledIcon />,
      href: "/about",
    },
    {
      title: t("Sidebar.Support"),
      icon: <SupportAgentIcon />,
      href: "/support",
    },
  ];
  const logout = [
    {
      title: t("Sidebar.LogOut"),
      icon: <LogoutIcon />,
      href: "",
    },
  ];
  const [version, setVersion] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate(); // Hook for navigation
  const { type } = useSelector((state) => state.user);

  const handleLogOut = async () => {
    try {
      // SweetAlert confirmation dialog
      const result = await Swal.fire({
        title: t("Sidebar.LogOut"),
        text: t("Sidebar.LogOutT"),
        icon: "",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Upload.Confirm"),
        cancelButtonText: t("Upload.Cancel"),
      });

      // If the user confirms the logout
      if (result.isConfirmed) {
        const res = await LogOut();
        navigate("/auth/login");
        const userData = res.data.value;
        dispatch(clearUserCredentials(userData));
      }
    } catch (error) {
      // Show error alert if logout fails
      Swal.fire("Error", "Something went wrong. Please try again.", "error");
    }
  };
  const getVersion = async () => {
    try {
      const res = await ListUpdate();
      const ver = res.data.version;
      setVersion(ver);
    } catch (error) {}
  };
  useEffect(() => {
    getVersion();
  }, []);

  const list = (anchor) => (
    <Box
      dir="rtl"
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 270 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box sx={{ padding: "0.7rem" }}>
        <IconButton
          aria-label="delete"
          onClick={toggleDrawer(anchor, false)}
          onKeyDown={toggleDrawer(anchor, false)}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <List sx={{ paddingTop: "0", paddingBottom: "0" }}>
        {profile.map((i) => {
          return <NavItem key={i.title} {...i} />;
        })}
        {type === 2 && (
          <>
            <Link
              to="https://edu.copysa.ir/"
              target="_blank"
              className="flex rounded-3xl p-4  "
            >
              <ListItem
                disablePadding
                sx={{ border: "2px solid #512C63", borderRadius: "1.5rem" }}
              >
                <ListItemButton
                  className="rounded-3xl"
                  sx={{
                    py: 1,
                    px: 3,
                  }}
                >
                  <ListItemIcon>
                    <SchoolIcon sx={{ color: "#512C63" }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("Sidebar.Student Panel")}
                    sx={{ fontWeight: 600, color: "#512C63" }}
                  />
                </ListItemButton>
              </ListItem>
            </Link>
          </>
        )}
      </List>
      <Typography
        component="h6"
        variant="h6"
        sx={{ padding: "0.5rem 1rem", marginBottom: "0px" }}
      >
         {t("Sidebar.Services")}
      </Typography>
      <List sx={{ paddingTop: "0", paddingBottom: "0" }}>
        {services.map((i) => {
          return <NavItem key={i.title} {...i} />;
        })}
      </List>
      <Divider />
      <Typography component="h6" variant="h6" sx={{ padding: "0.5rem 1rem" }}>
        {t("Sidebar.Info")}
      </Typography>
      <List sx={{ paddingTop: "0", paddingBottom: "0" }}>
        {info.map((i) => {
          return <NavItem key={i.title} {...i} />;
        })}
      </List>
      <Divider />
      <List sx={{ paddingTop: "0", paddingBottom: "0" }}>
        {logout.map((i) => {
          return <NavItem key={i.title} {...i} handleClick={handleLogOut} />;
        })}
      </List>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          position: "relative",
          marginX: "auto",
          padding: ".5rem 0",
        }}
      >
        <Typography>
          {t("Sidebar.Version")} {version}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Box className="hidden" dir="rtl">
      {["right", "left"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Drawer
            anchor={document.dir === "rtl" ? "left" : "right"}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </Box>
  );
}
